export const authLink = 'inline-flex min-h-11 items-center text-sm font-semibold text-sky-950 underline-offset-4 '
  + 'hover:text-violet-900 hover:underline focus-visible:outline-2 focus-visible:outline-offset-4 '
  + 'focus-visible:outline-violet-700';
